import { render, staticRenderFns } from "./MicroCategory.vue?vue&type=template&id=54d6b525&scoped=true&"
import script from "./MicroCategory.vue?vue&type=script&lang=js&"
export * from "./MicroCategory.vue?vue&type=script&lang=js&"
import style0 from "./MicroCategory.vue?vue&type=style&index=0&id=54d6b525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d6b525",
  null
  
)

export default component.exports